/**
 * Pseudônimo de dispositivo + consentimento de histórico (localStorage).
 * Não identifica a pessoa; some se o storage for limpo / outro browser.
 */
const VISITOR_KEY = 'dw_visitor_key';
const CONSENT_KEY = 'dw_consent_history';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function randomUuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getVisitorKey() {
  try {
    const existing = localStorage.getItem(VISITOR_KEY);
    if (existing && UUID_RE.test(existing)) return existing.toLowerCase();
    const next = randomUuid().toLowerCase();
    localStorage.setItem(VISITOR_KEY, next);
    return next;
  } catch {
    return randomUuid().toLowerCase();
  }
}

/** Histórico/sugestões ficam sempre ativos neste dispositivo (política do produto). */
export function getConsentHistory() {
  try {
    localStorage.setItem(CONSENT_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
  return true;
}

export function setConsentHistory(_value) {
  try {
    localStorage.setItem(CONSENT_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
  return true;
}

export function getReferrer() {
  try {
    return document.referrer || '';
  } catch {
    return '';
  }
}
